import { useQuery } from '@tanstack/react-query';
import { ExchangeRateApiClient, ExchangeRateMap } from 'api/exchangeRate';

export const useLatestExchangeRates = (enabled: boolean = true) => {
  return useQuery<ExchangeRateMap>({
    queryKey: ['exchange-rates', 'latest'],
    queryFn: () => ExchangeRateApiClient.getLatest(),
    enabled,
    staleTime: 1000 * 60 * 10,
  });
};

